export default [{
	path: '/:amp?/features',
	component: () => import(/* webpackChunkName: 'Features' */ './FeaturesHome.vue'),
	props: true,
	children: [
		{
			path: '/',
			name: 'features',
			component: () => import(/* webpackChunkName: 'Features' */ './FeaturesIndex.vue'),
			props: true
		},
		{
			path: ':featureParent?/:code',
			name: 'feature-article',
			component: () => import(/* webpackChunkName: 'Features' */ './Features.vue'),
			props: true
		},
		{ path: '*', redirect: '/features' }
	]
}];